exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menuable__content__active{z-index:10000!important}.header-icon-wrapper{text-align:center}.header-icon-wrapper img{border:1px solid #ddd;border-radius:4px;padding:5px;width:100%;height:250px}.header-icon-wrapper .v-icon{font-size:3rem;padding:25px;border-radius:50%;border:4px solid #3fa2f7}.wrapper-title{text-align:center;margin-top:5%;color:#3fa2f7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44606a3e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AddScreenshotDialog.vue
// module id = 858
// module chunks = 0